// Source: https://emailregex.com/
// eslint-disable-next-line max-len
export const REGEX_EMAIL =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// stripped down version of email regex
export const REGEX_DOMAIN =
  /^((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Pattern for trailing or leading whitespaces
export const REGEX_NO_LEADING_OR_TRAILING_WHITESPACES = /^[^\s]+(\s+[^\s]+)*$/;

export const MESSAGE_DISPLAY_TIMEOUT_MS = 5000;

export const defaultConversationNodeColors = [
  '#5470c6',
  '#91cc75',
  '#fac858',
  '#ee6666',
  '#73c0de',
  '#3ba272',
  '#fc8452',
  '#9a60b4',
  '#ea7ccc',
  '#48cae4',
  '#0096c7',
  '#ffb4a2',
  '#40916c',
  '#eeef20',
  '#f48c06',
  '#7f5539',
  '#b08968',
  '#ddb892',
  '#02c39a',
  '#028090',
  '#faedcd',
  '#c1d3fe',
  '#f7d6e0',
  '#a53860',
  '#ffa5ab',
  '#f5ebe0',
];
